import { createAsyncThunk } from '@reduxjs/toolkit';
import labApi from '../../core/api/lab.api';
import { GetStagingPickListResponse } from '../../core/api/lab.types';

export const getStagingPickListThunk = createAsyncThunk(
  'shipment/getStagingPickList',
  async (_, { rejectWithValue }: any) => {
    const response: GetStagingPickListResponse = await labApi.getStagingPickList();
    if (response.data?.getStagingPickList) {
      return response.data.getStagingPickList;
    }

    return rejectWithValue(response.errors);
  },
);
